<template>
  <v-container fluid grid-list-sm class="header-container">
    <v-layout row wrap>
      <v-flex
        xs12
        pa-3
        class="header-content text-xs-center white--text headline font-weight-medium"
      >
        Leave Calendar
      </v-flex>

      <v-container fluid grid-list-sm>
        <v-card-text>
          <v-icon color="white" @click="movePrevMonth(SelectedMonth.value)">
            mdi-chevron-left
          </v-icon>
          {{ SelectedMonth.label }} - {{ SelectedMonth.year }}
          <v-icon color="white" @click="moveNextMonth(SelectedMonth.value)">
            mdi-chevron-right
          </v-icon>
        </v-card-text>
        <v-flex xs12>
          <v-data-table
            ref="reportsTable"
            :headers="headers"
            :items="activePipefishUsers"
            :search="search"
            class="elevation-1"
            :class="{ 'weekend': (weekend.indexOf(getDay(d)) > -1)}"
            sort-icon="mdi-menu-down"
            v-if="headers.length > 1"
            hide-actions
          >
            <template v-slot:items="props">
              <tr>
                <td class="headcol">{{ props.item.GivenName }} {{ props.item.Surname }}</td>
                  <td v-for="(d, j) in days" :key="j" :class="{ 'weekend': (weekend.indexOf(getDay(d)) > -1)}">
                    {{ leaveForDate(props.item, d) }}
                  </td>
              </tr>
            </template>
          </v-data-table>
      </v-flex>
      </v-container>

      <v-container fluid grid-list-sm>
        <table>
          <thead>
            <tr>
              <th>Leave Name</th>
              <th>Leave Code</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="c in codes" :key="c.Code">
              <td>{{ c.Name }}</td>
              <td>{{ c.Code }}</td>
            </tr>
          </tbody>
        </table>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  data: () => ({
    leave: [],
    days: [],
    weekend: ['Sat', 'Sun'],
    SelectedMonth: {
      value: new Date().getMonth(),
      label: moment()
        .month(new Date().getMonth())
        .format("MMMM"),
      year: new Date().getFullYear()
    },
    codes: [],
    headers: [{
      text: 'Employee', value: 'Employee', sortable: true
    }],
    baseHeader: {
      text: 'Employee', value: 'Employee', sortable: true
    }
  }),
  created() {
    let self = this;
    this.getDaysInMonth(this.SelectedMonth.value);
    for(var i = 0; i < this.days.length; i++) {
      this.headers.push({text: this.days[i], value: this.days[i], sortable: false})
    }

    if (this.pipefishUsers.length == 0) {
      this.$timesheetApi.getAllUsers().then((response) => {
        self.setSortedPipefishUsers(response);
      });
    }

    this.$timesheetApi.getLeaves().then((response) => {
      let leaves = [];
      for (var r = 0; r < response.length; r++) {
        let pLeave = leaves.filter((obj) => obj.Id == response[r].me.Id);
        if (pLeave.length == 0) {
          leaves.push({
            Id: response[r].me.Id,
            name: response[r].me.GivenName,
            leave: [
              { activity: response[r].activity, date: response[r].WorkedOn },
            ],
          });
        } else {
          pLeave[0].leave.push({
            activity: response[r].activity,
            date: response[r].WorkedOn,
          });
        }
      }
      self.leave = leaves;
    });

    this.$timesheetApi.getLeaveCodes().then(res => {
      self.codes = res;
    })
  },
  computed: {
    ...mapState("admin", ["pipefishUsers"]),
    activePipefishUsers: function() {
      return this.pipefishUsers.filter((obj) => obj.IsActive)
    }
  },
  methods: {
    ...mapActions("admin", ["setSortedPipefishUsers"]),
    leaveForDate: function(person, day, leave) {
      var leave = "";
      var month =
        this.SelectedMonth.value + 1 < 10
          ? "0" + (this.SelectedMonth.value + 1)
          : this.SelectedMonth.value + 1;
      day = day.toString().length == 1 ? '0' + day : day;
      var date = `${day}-${month}-${this.SelectedMonth.year}`;
      var personLeave = this.leave.filter(obj => obj.Id == person.id);
      if (personLeave.length > 0) {
        var currentLeave = personLeave[0].leave.filter(
          (obj) => moment(obj.date).format("DD-MM-YYYY") == date
        );
        if (currentLeave.length > 0) {
          leave = currentLeave[0].activity.Code;
        }
        
        return leave;
      }
      return '';
    },
    getDaysInMonth: function(month) {
      let daysInMonth = moment([this.SelectedMonth.year, month]).daysInMonth();
      var days = [];
      for(var i = 1; i <= daysInMonth; i++) {
        days.push('' + i);
      }
      this.days = [];
      this.days = days;
    },
    getDay: function(day) {
      var day = moment([this.SelectedMonth.year,this.SelectedMonth.value,day]).format('ddd');
      return day;
    },
    movePrevMonth: function(month) {
      var currentMonth = month;
      var previousMonth = currentMonth - 1
      if(previousMonth < 0) {
        this.SelectedMonth.year -= 1
        previousMonth = 11;
      } 
      this.getDaysInMonth(previousMonth);
      this.headers = [this.baseHeader]
      for(var i = 0; i < this.days.length; i++) {
        this.headers.push({text: this.days[i], value: this.days[i], sortable: false})
      }
      this.SelectedMonth.value = previousMonth;
      this.SelectedMonth.label = moment().month(previousMonth).format('MMMM');
    },
    moveNextMonth: function(month) {
      var currentMonth = month;
      var nextMonth = (currentMonth + 1) % 12;
      if(nextMonth == 0) {
        this.SelectedMonth.year += 1
      }
      this.getDaysInMonth(nextMonth);
      this.headers = [this.baseHeader]
      for(var i = 0; i < this.days.length; i++) {
        this.headers.push({text: this.days[i], value: this.days[i], sortable: false})
      }
      this.SelectedMonth.value = nextMonth;
      this.SelectedMonth.label = moment().month(nextMonth).format('MMMM');
    },
  },
};
</script>

<style>
/* td.leave-cal,
th.leave-cal {
  border: 3px solid grey;
  white-space: nowrap;
  margin: 20px;
  padding: 20px;
}

th {
  text-align: center;
}

.headcol {
  position: sticky;
 left: 0px;
 z-index: 1;
 background-color: white;
}

.leave-table {
  width: 95%;
  overflow-x: scroll;
  margin-left: 5em;
  overflow-y: visible;
  padding-bottom: 1px;
}

.weekend {
  background-color: darkgrey;
} */
</style>
